module.exports = __webpack_public_path__ + "static/media/Hackathon-logo-1.e586adbe.png";